import React, { useState, ReactNode } from "react";
import  "./BaseCard.css";

interface BaseCardProps {
  id: string;
  defaultExpanded?: boolean;
  className?: string;
  renderHeader: (props: { isExpanded: boolean; onToggle: () => void }) => ReactNode;
  children: ReactNode;
}

const BaseCard: React.FC<BaseCardProps> = ({
  id,
  defaultExpanded = false,
  className = "",
  renderHeader,
  children,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const handleToggle = () => setIsExpanded(prev => !prev);

  return (
    <div
      className={`base-card ${isExpanded ? "expanded" : ""} ${className}`}
      data-card-id={id}
    >
      {renderHeader({ isExpanded, onToggle: handleToggle })}
      {isExpanded && <div className="base-card-content">{children}</div>}
    </div>
  );
};

export default BaseCard;